export namespace ReplacementCardRequestActions {
    export class GetConfiguration {
        public static readonly type = "[ReplacementCardRequest] GetDefaultValues";
    }
    export class Create {
        public static readonly type = "[ReplacementCardRequest] Create";
    }

    export class ResetForm {
        public static readonly type = "[ReplacementCardRequest] ResetForm";
    }
}
